export const RAW_RESOURCES = ['wood', 'stone', 'clay', 'ore'] as const;
export const MANUFACTURED_RESOURCES = ['glass', 'papyrus', 'textile'] as const;
export const RESOURCES = [...RAW_RESOURCES, ...MANUFACTURED_RESOURCES] as const;

export type RawResource = (typeof RAW_RESOURCES)[number];
export type ManufacturedResource = (typeof MANUFACTURED_RESOURCES)[number];
export type Resource = RawResource | ManufacturedResource;
export type ResourceCount = Partial<Record<Resource, number>>;

export const COLORS = ['brown', 'grey', 'blue', 'yellow', 'red', 'green', 'purple'] as const;
export type Color = (typeof COLORS)[number];

export const SCIENCE_SYMBOLS = ['compass', 'gear', 'tablet'] as const;
export type ScienceSymbol = (typeof SCIENCE_SYMBOLS)[number];

/** Lado relativo: `left` es el vecino de la izquierda, `right` el de la derecha. */
export type Side = 'left' | 'right';
export const SIDES: readonly Side[] = ['left', 'right'];
export type Scope = 'self' | Side;

export type Age = 1 | 2 | 3;
export type WonderSide = 'day' | 'night';

/** Notación compacta: W madera, S piedra, C arcilla, O mineral, G vidrio, P papiro, L tela. */
export const RESOURCE_LETTERS: Record<string, Resource> = {
  W: 'wood',
  S: 'stone',
  C: 'clay',
  O: 'ore',
  G: 'glass',
  P: 'papyrus',
  L: 'textile',
};

export function isRaw(r: Resource): r is RawResource {
  return (RAW_RESOURCES as readonly string[]).includes(r);
}

export function countTotal(rc: ResourceCount): number {
  let n = 0;
  for (const r of RESOURCES) n += rc[r] ?? 0;
  return n;
}

export function addCounts(a: ResourceCount, b: ResourceCount): ResourceCount {
  const out: ResourceCount = { ...a };
  for (const r of RESOURCES) {
    const v = (a[r] ?? 0) + (b[r] ?? 0);
    if (v) out[r] = v;
    else delete out[r];
  }
  return out;
}

export function normalizeCount(rc: ResourceCount): ResourceCount {
  const out: ResourceCount = {};
  for (const r of RESOURCES) {
    const v = rc[r] ?? 0;
    if (v > 0) out[r] = v;
  }
  return out;
}
